import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & { animate?: boolean }
>(({ className, value, animate = false, ...props }, ref) => {
  const isRtl = typeof document !== "undefined" && document.documentElement.dir === "rtl";
  const [mounted, setMounted] = React.useState(!animate);
  const offset = 100 - (mounted ? (value || 0) : 0);

  React.useEffect(() => {
    if (animate) {
      const id = requestAnimationFrame(() => setMounted(true));
      return () => cancelAnimationFrame(id);
    }
  }, [animate]);

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-primary transition-all duration-1000 ease-out"
        style={{ transform: `translateX(${isRtl ? "" : "-"}${offset}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
